import React from "react";

export default function PrivacyPolicy(){
    return (
        <>
            <a className="text-dark" href='https://www.crlcorp.com/notice-of-privacy-practices/' target="_blank">
                <strong>Privacy Policy</strong>
            </a>
        </>
    )
}
